import React, { Component } from "react";
import { FormGroup, FormControl, FormLabel } from "react-bootstrap";
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation, Trans } from 'react-i18next';
import * as userActions from 'actions/userActions';
import { appService } from "services";
import SubmitButton from "components/SubmitButton";
import Loading from "components/Loading";
import Logo from "components/Logo";
import { transLnkComponents } from "utils/i18nComponents";
import { getAppName } from 'utils/utils';

class Invitation extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isFound: false,
			isLoading: true,
			isSending: false,
			isChanged: false,
			name: '',
			surname: '',
			company: '',
			email: '',
			password_new: '',
			confirmPassword: '',
		};
	}

	async componentDidMount() {
		const response = await appService.getInvitation(this.props.match.params.token);

		if (response.ok) {
			const { name, surname, email, company } = response;
			this.setState({ name, surname, email, company: company.name, isFound: true, isLoading: false });
		} else {
			this.setState({ isLoading: false });
		}
	}

	validateForm() {
		const { password_new, confirmPassword } = this.state;
		return password_new.length > 5 && password_new === confirmPassword;
	}

	handleChange = event => {
		this.setState({ [event.target.id]: event.target.value });
	}

	handleSubmit = async event => {
		event.preventDefault();
		this.setState({ isSending: true });
		const response = await appService.postInvitationPassword(this.props.match.params.token, this.state.password_new);
		this.setState({
			password_new: '',
			confirmPassword: '',
			isChanged: response.ok,
			isSending: false,
		});
	}

	getContent = () => {
		const { t } = this.props;

		if (this.state.isLoading) return <Loading />;

		if (!this.state.isFound) {
			return (
				<div className="notfound">
					<p>
						<Trans
							i18nKey="invitation.alreadyActive"
							components={transLnkComponents.login}
						/>
					</p>
				</div>
			);
		}

		const { name, surname, email, company, password_new, confirmPassword } = this.state;
		const appName = getAppName();

		return (
			<>
				<div className="login-title">{t('invitation.activateAccount')}</div>

				<p className="hello">
					<Trans i18nKey="invitation.hello" values={{ name }}>
						<strong>{{name}}</strong>
					</Trans>
					{' '}<span className="emoji" role="img" aria-label="hello">&#128075;</span>
					<br />
					{t('invitation.setPasswordHint', { appName })}
				</p>

				<form onSubmit={this.handleSubmit} className="login-form">
					<ul className="user-data">
						<li>{name} {surname}</li>
						<li><strong>{company}</strong></li>
						<li>{email}</li>
					</ul>

					<FormGroup className="form-group login-form-group" controlId="password_new">
						<FormLabel>{t('login.password')} <span className="label-required">*</span></FormLabel>
						<FormControl
							value={password_new}
							onChange={this.handleChange}
							type="password"
							placeholder="••••••••"
						/>
					</FormGroup>
					<FormGroup controlId="confirmPassword" className="form-group login-form-group">
						<FormLabel>{t('invitation.passwordConfirm')} <span className="label-required">*</span></FormLabel>
						<FormControl
							value={confirmPassword}
							onChange={this.handleChange}
							type="password"
							placeholder="••••••••"
						/>
					</FormGroup>
					<SubmitButton
						block
						disabled={!this.validateForm()}
						type="submit"
						isLoading={this.state.isSending}
						text={t('invitation.activateBtn')}
						loadingText={t('invitation.activating')}
					/>
				</form>

				{this.state.isChanged && (
					<div className="alert alert-success alert-dismissible fade show" role="alert">
						<Trans
							i18nKey="invitation.successMessage"
							components={transLnkComponents.login}
						/>
					</div>
				)}
			</>
		);
	}

	render() {
		return (
			<div className="Auth">
				<div className="login-container acenter">
					<Logo className="logo" type="logo" />
					{this.getContent()}
				</div>
			</div>
		);
	}
}

const mapStateToProps = (reducers) => reducers.authReducer;

export default connect(mapStateToProps, userActions)(withTranslation()(Invitation));
